<template>
  <div class="activity-enroll-list-page" :class = "{'clear-header':isWechatBrowser}">
    <my-header title="我的活动" v-if="!isWechatBrowser" :showBack="true"></my-header>
    <div  v-if="activityEnrollList.length>0">
      <div class="activity-enroll-list general-box-shadow" v-for="activityEnroll in activityEnrollList">
        <div class="activity-item"  @click="toActivityEntity(activityEnroll.activityEntity.id)">
          <img class="activity-banner" :src="imgUrl+activityEnroll.activityEntity.image"/>
          <div class="activity-info">
            <div class="activity-title">{{activityEnroll.activityEntity.title}}</div>
            <div class="activity-time">活动时间：{{activityEnroll.activityEntity.activityDay}}</div>
            <div v-if="activityEnroll.activityEntity.status == 1" class="activity-status status-enroll">已报名</div>
            <div v-if="activityEnroll.activityEntity.status == 2" class="activity-status status-start">已开始</div>
            <div v-if="activityEnroll.activityEntity.status == 3" class="activity-status status-end">已结束</div>
          </div>
        </div>
      </div>
    </div>
    <div class="black-page" v-if="activityEnrollList.length==0">
      <img src="../../assets/icon-no-img.png">
      <div class="tip">您还未参加活动哦</div>
    </div>
  </div>
</template>

<script>
  import {imgUrl} from '../../config'
  import {Toast} from 'mint-ui'
  import Header from '../../components/header/Header'
  import activityCustomerEnrollService from '../../service/activity/ActivityCustomerEnrollService'

  export default {
    name: 'AddressList',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        activityEnrollList:[],
        imgUrl:imgUrl,
        isPreStart: false,
        isEnd: false,
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.isWechatBrowser = this.$route.meta.isWechatBrowser;
      this.getActivityEnrollList();
    },
    methods: {
      async getActivityEnrollList(){
        let {code,msg,data} = await activityCustomerEnrollService.list();
        if(code == '0'){
          this.activityEnrollList = data.result;
          this.activityEnrollList.reverse();
          for(let activityEnroll of this.activityEnrollList){
            if(activityEnroll.activityEntity.title.length > 13){
              activityEnroll.activityEntity.title = activityEnroll.activityEntity.title.substring(0,13)+ '...';
            }
            if(activityEnroll.activityEntity.activityDay.length > 22){
              activityEnroll.activityEntity.activityDay = activityEnroll.activityEntity.activityDay.substring(0,22)+ '...';
            }
            let now = new Date();
            if (now.getTime() < activityEnroll.activityEntity.startTime) {
              //活动已报名
              activityEnroll.activityEntity.status = 1
            } else if (activityEnroll.activityEntity.startTime <= now.getTime() && now.getTime() < activityEnroll.activityEntity.endTime时) {
              //活动进行中
              activityEnroll.activityEntity.status = 2
            } else {
              //活动已结束
              activityEnroll.activityEntity.status = 3
            }
          }
        }else {
          Toast(msg);
        }
      },
      toActivityEntity(id){
        this.$router.push({name: 'ActivityDetail', query: {activityId:id}})
      }
    }
  }
</script>

<style lang="scss">
  @import '../../assets/style/common.scss';
  .activity-enroll-list-page{
    padding-top: 0.3rem;
    font-size: 0.28rem;
    text-align: left;
    background: white;
  }
  .activity-enroll-list{
    width: 6.9rem;
    margin: 0.2rem auto 0;
    padding-bottom: 0.19rem;
    .activity-item{
      display: flex;
      height: 1.69rem;
    }
    .activity-banner{
      width: 1.3rem;
      height: 1.3rem;
      border: 0.06rem;
      border-radius: 6px;
      margin: 0.2rem 0 0.2rem 0.2rem;
    }
    .activity-info{
      width: 5.2rem;
      padding-left: 0.3rem
    }
    .activity-title{
      font-size: 0.32rem;
      font-weight: bold;
      margin-top: 0.1rem;
    }
    .activity-content{
      font-size: 0.28rem;
      color: #7f7d7c;
      margin-top: 0.1rem;
      margin-bottom: 0.1rem;
    }
    .activity-time{
      font-size: 0.28rem;
      color: #7f7d7c;
      margin-top: 0.07rem;
      margin-bottom: 0.05rem;
    }
    .activity-status{
      width: 1.1rem;
      height: 0.4rem;
      border-radius: 20px;
      font-size: 0.24rem;
      line-height: 0.45rem;
      text-align: center;
    }
    .status-enroll{
      background:rgba(29,138,231,0.2);
      color: #1d8ae7;
    }
    .status-start{
      background: rgba(46,213,115,0.2);
      color: #2ED573;
    }
    .status-end{
      background:rgba(255,117,68,0.2);
      color: #ff7544;
    }
  }

</style>
